module.exports = __webpack_public_path__ + "media/images/claim_profile/visibility-8b0b6a0f42b858b9b7032c1e95495d5c.png";